// app/components/ui/buttons/SearchButton.tsx
'use client';

import { motion } from 'framer-motion';
import Icon from '../icons/Icon';
import { getActiveLocale } from '@/utils/active-locale';

export default function SearchButton({
  onClick,
}: {
  onClick?: () => void;
}) {
  const activeLocale = getActiveLocale();
  const translations = { en: 'Find', nl: 'Vind' };

  return (
    <motion.button
      type="button"
      onClick={onClick}
      // expand both on hover *and* on tap
      whileHover="hover"
      whileTap="hover"
      initial="rest"
      animate="rest"
      variants={{
        rest: { width: 56, height: 56 },
        hover: { width: 140 },
      }}
      className="bg-yellow-600 rounded-full flex items-center justify-center overflow-hidden"
    >
      <div className="flex items-center">
        <Icon name="search" className="text-dark-900 text-xl" />
        <motion.span
          variants={{
            rest: { opacity: 0, width: 0 },
            hover: { opacity: 1, width: 64 },
          }}
          className="text-dark-900 text-xl overflow-hidden whitespace-nowrap"
        >
          {translations[activeLocale]}
        </motion.span>
      </div>
    </motion.button>
  );
}